<template>
    <div id="contenedor-principal-permisos" class="container-fluid">
        <div id="encabezados-tp">
            <h1>ADMINISTRACIÓN DE PERMISOS INTRANET</h1>
            <h3>Asigna los permisos para las paginas y secciones de intranet</h3>
            <div class="hr-titulo"></div>
        </div>
        <!-- SECCION PRINCIPAL PARA PERMISOS -->
        <div class="row" style="margin-top: 3em;">
            <div class="row no-gutters col-xs-12 col-sm-12 col-md-12 col-lg-12 pr-2 pt-2">
                <div class="form-group col-xs-4 col-sm-4 col-md-4 col-lg-4">
                    <h6 for="estatus-resultado">Elige el tipo de permiso</h6>
                    <CCatalogoGenerico class="p-0 m-0" 
                        v-on:valorParaElPadre="evtCambioTipoPermiso" 
                        :prefijo="enumeraciones.etiquetasDeHTML.Select" 
                        :tipo="enumeraciones.tiposDeSelect.Seleccione" 
                        :idDelInput="CtiposDePermisos.ID" 
                        :valorDefinido="CtiposDePermisos.valorDefinido"
                        :textoOpcionesSingular="''"
                        :textoOpcionesPlural="''"
                        :elementosCatalogo="CtiposDePermisos.opciones"
                        :conOpcionDeinstrucciones="CtiposDePermisos.mostrarSoloOpcionesValidas"
                        :key="CtiposDePermisos.KEY + CtiposDePermisos.contRender"></CCatalogoGenerico>
                </div>
            </div>
            <!-- TIPOS DE PERMISOS -->
            <div v-if="campoEsValido({ campoAValidar: CtiposDePermisos.seleccionado })" class="col-xs-12 col-sm-12 col-md-12 col-lg-12 pr-2 pt-2">
                <div class="card">
                    <div class="card-header">
                        <div class="form-inline justify-content-between flex-wrap">
                            <h5><strong>{{ convertirCadenaAMayusculas({ cadena: CtiposDePermisos.seleccionado.valor }) }}</strong></h5>
                             <button v-if="mostrarOpcionGuardarPermisosDePagina" type="button" @click="iniciarProcesoGuardarPermisosDePagina" 
                                    class="btn btn-sm btn-light"><i class="fas fa-save"></i>&nbsp;&nbsp;Guardar permisos</button>
                             <button v-if="mostrarOpcionGuardarPermisosDeSeccion" type="button" @click="iniciarProcesoGuardarPermisosDeSeccion({ desdeModal: false })" 
                                    class="btn btn-sm btn-light"><i class="fas fa-save"></i>&nbsp;&nbsp;Guardar permisos</button>
                        </div>
                    </div>
                    <div class="card-body">
                        <!-- SECCION PARA PERSMISOS DE SECCIONES INTRANET -->
                        <div v-if="this.CtiposDePermisos.valorDefinido == this.CtiposDePermisos.TIPOS.SECCIONES" id="caso-por-secciones" class="row no-gutters col-xs-12 col-sm-12 col-md-12 col-lg-12 pr-2 pt-2">
                            <!-- VERSION 2 -->
                            <h5>
                                <strong>[1]&nbsp;&nbsp;Busqueda de usuario&nbsp;&nbsp;
                                <i @click="formularioUsuarios.mostrarFiltrosBusqueda = !formularioUsuarios.mostrarFiltrosBusqueda" 
                                   :class="[(formularioUsuarios.mostrarFiltrosBusqueda) ? 'fas fa-caret-square-up' : 'fas fa-caret-square-down']"
                                   style="cursor: pointer;"></i></strong>
                            </h5>
                            <form v-show="formularioUsuarios.mostrarFiltrosBusqueda" @submit="ejecutarProcesoBusquedaDeUsuarios($event)" class="formulario row no-gutters col-xs-12 col-sm-12 col-md-12 col-lg-12">
                                <div class="form-group col-xs-4 col-sm-4 col-md-4 col-lg-4 pr-4">
                                    <h6>Nombre</h6>
                                    <input v-model="formularioUsuarios.nombre" type="text" class="form-control" placeholder="Ingrese el nombre del usuario" />
                                </div>
                                <div class="form-group col-xs-4 col-sm-4 col-md-4 col-lg-4 pr-4">
                                    <h6>Apellido paterno</h6>
                                    <input v-model="formularioUsuarios.apellidoPaterno" type="text" class="form-control" placeholder="Ingrese el apellido paterno del usuario" />
                                </div>
                                <div class="form-group col-xs-4 col-sm-4 col-md-4 col-lg-4 pr-4">
                                    <h6>Apellido materno</h6>
                                    <input v-model="formularioUsuarios.apellidoMaterno" type="text" class="form-control" placeholder="Ingrese el apellido materno del usuario" />
                                </div>
                                <div class="form-group col-xs-4 col-sm-4 col-md-4 col-lg-4 pr-4">
                                    <h6>Correo</h6>
                                    <input v-model="formularioUsuarios.correo" type="text" class="form-control" placeholder="Ingrese el correo del usuario" />
                                </div>
                                <div class="form-group col-xs-4 col-sm-4 col-md-4 col-lg-4 pr-4 align-self-end">
                                    <button type="submit" class="btn btn-sm btn-light"><i class="fas fa-search"></i>&nbsp;&nbsp;Buscar usuario</button>
                                </div>
                            </form>
                            <div v-if="formularioUsuarios.tabla.visible" class="tabla-VADPI-intranet" :class="[(formularioUsuarios.mostrarFiltrosBusqueda) ? 'pt-4' : 'pt-1']">
                                <div id="toolbar-tabla-usuarios">
                                    <div class="form-inline flex-wrap mt-2" style="gap: 0.5em !important;">
                                        <h5 class="form-inline"><strong>Usuarios encontrados</strong></h5>
                                    </div>
                                </div>
                                <table
                                    class="table table-striped table-light table-hover"
                                    :id="formularioUsuarios.tabla.ID"              
                                    data-toggle="table"
                                    data-pagination="true"
                                    data-search-align="right"
                                    data-toolbar="#toolbar-tabla-usuarios" 
                                    data-toolbar-align="left"
                                    data-undefined-text="Sin información" 
                                    data-maintain-meta-data="true"
                                    data-click-to-select="true"
                                    data-page-size = "3"
                                    data-page-list="[1, 2, 3 ,5,10,20,30]"
                                    data-show-toggle="true"
                                    data-show-pagination-switch="true"
                                    data-search="true">
                                    <thead class="thead-dark">
                                        <tr>
                                            <th data-halign="center" data-width="10" data-align="center" data-field="seleccionado" data-formatter="deshabilitarSeleccionUsuarios"  data-checkbox="true"></th>
                                            <th data-halign="center" data-width="10" data-align="center" data-field="IdUsuario" data-sortable="true">
                                                Id
                                            </th>
                                            <th data-halign="center" data-width="30" data-align="center" data-field="Nombre" data-sortable="true">
                                                Nombre
                                            </th>
                                            <th data-halign="center" data-width="20" data-align="center" data-field="NombreArea" data-sortable="true">
                                                Area
                                            </th>
                                            <th data-halign="center" data-width="15" data-align="center" data-field="NombrePuesto" data-sortable="true">
                                                Puesto
                                            </th>
                                             <th data-halign="center" data-width="15" data-align="center" data-events="operateEvents" data-field="accionHTML" data-sortable="true"></th>
                                        </tr>
                                    </thead>
                                </table>
                            </div>
                            <div v-if="mostrarAsignacionSecciones" class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                                <hr style="border: 1px solid rgb(40, 40, 44); margin-bottom: 0em;"/>
                            </div>
                            <div v-show="mostrarAsignacionSecciones" class="row no-gutters col-xs-12 col-sm-12 col-md-12 col-lg-12 pt-4" style="margin-top: 1em;">
                                <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 pb-4">
                                   <div class="form-inline flex-wrap" style="gap: 2.5em !important;">
                                        <h5><strong>[2]&nbsp;&nbsp;Asigna las secciones a los usuarios</strong></h5>
                                        <button v-if="formularioUsuarios.tablaTemporalPermisos.lista.length > 0"
                                                @click="accionEnModal({ idModal: 'modal-permisos-seccion-usuarios-VADPI', mostrar: true, cargarTabla : { idTabla: formularioUsuarios.tablaTemporalPermisos.ID, elementos: formularioUsuarios.tablaTemporalPermisos.lista } })" 
                                                type="button" class="btn btn-sm btn-dark"><i class="fas fa-eye"></i>&nbsp;&nbsp;ver lista de permisos</button>
                                   </div>
                                </div>
                                <div class="col-xs-5 col-sm-5 col-md-5 col-lg-5 pr-3">
                                    <div class="formulario">
                                        <div :class="[campoEsValido({ campoAValidar: formularioUsuarios.CPaginas.paginaId }) ? 'form-inline justify-content-between flex-wrap' : 'form-inline']">
                                            <h5><strong>Filtra la secciones</strong></h5>
                                            <button v-if="campoEsValido({ campoAValidar: formularioUsuarios.CPaginas.paginaId })" @click="ejecutarProcesoBusquedaDeSecciones" type="button" class="btn btn-sm btn-light"><i class="fas fa-search"></i>&nbsp;&nbsp;Buscar secciones</button>
                                        </div>
                                        <hr style="border: 1px solid rgb(45, 44, 44); margin-top: 1em;"/>
                                        <div class="form-group mt-4">
                                            <h6>Área de intranet</h6>
                                            <C030AreasDeIntranet 
                                                class="p-0 m-0"
                                                v-on:valorParaElPadre="evtCambioTipoArea" 
                                                :prefijo="enumeraciones.etiquetasDeHTML.Select" 
                                                :tipo="enumeraciones.tiposDeSelect.Seleccione" 
                                                :idDelInput="formularioUsuarios.CAreas.id" 
                                                :parametros="formularioUsuarios.CAreas.parametros" 
                                                :valorDefinido="formularioUsuarios.CAreas.areaId"
                                                :key="formularioUsuarios.CAreas.key + formularioUsuarios.CAreas.contRender"></C030AreasDeIntranet>
                                        </div>
                                        <!-- FILTRO TIPO DE PAGINA INTRANET -->
                                        <div v-if="campoEsValido({ campoAValidar: formularioUsuarios.CAreas.areaId })" class="form-group">
                                            <h6>Página de intranet</h6>
                                            <C029PaginasDeIntranet class="p-0 m-0" 
                                                v-on:valorParaElPadre="evtCambioTipoPagina" 
                                                :prefijo="enumeraciones.etiquetasDeHTML.Select" 
                                                :tipo="enumeraciones.tiposDeSelect.Seleccione" 
                                                :idDelInput="formularioUsuarios.CPaginas.id" 
                                                :parametros="formularioUsuarios.CPaginas.parametros" 
                                                :valorDefinido="formularioUsuarios.CPaginas.paginaId"
                                                :key="formularioUsuarios.CPaginas.key + formularioUsuarios.CPaginas.contRender"></C029PaginasDeIntranet>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-xs-7 col-sm-7 col-md-6 col-lg-7 pl-4">
                                    <div v-if="formularioUsuarios.tablaSecciones.visible" class="tabla-VADPI-intranet">
                                        <div id="toolbar-tabla-secciones-permisos">
                                            <button v-if="formularioUsuarios.tablaSecciones.lista.filter(s => s.seleccionado).length > 0" type="button" class="btn btn-sm btn-info" @click="agregarSeccionListaTemporalPermisos">
                                                <i class="fas fa-plus"></i>&nbsp;&nbsp;Agregar&nbsp;({{ formularioUsuarios.tablaSecciones.lista.filter(s => s.seleccionado).length }})
                                            </button>
                                        </div>
                                        <table
                                            class="table table-striped table-light table-hover"
                                            :id="formularioUsuarios.tablaSecciones.ID"              
                                            data-toggle="table"
                                            data-pagination="true"
                                            data-search-align="right"
                                            data-toolbar-align="left"
                                            data-toolbar="#toolbar-tabla-secciones-permisos" 
                                            data-undefined-text="Sin información" 
                                            data-maintain-meta-data="true"
                                            data-click-to-select="true"
                                            data-page-size = "4"
                                            data-page-list="[4,5,10,20,30]"
                                            data-show-toggle="true"
                                            data-show-pagination-switch="true"
                                            data-search="true">
                                            <thead class="thead-dark">
                                                <tr>
                                                    <th data-halign="center" data-width="10" data-align="center" data-field="seleccionado"  data-checkbox="true"></th>
                                                    <th data-halign="center" data-width="10" data-align="center" data-field="seccionId" data-sortable="true">
                                                        Id
                                                    </th>
                                                    <th data-halign="center" data-width="40" data-align="center" data-field="nombre" data-sortable="true">
                                                        Nombre
                                                    </th>
                                                    <th data-halign="center" data-width="40" data-align="center" data-field="perteneceA" data-sortable="true">
                                                        Pertenece a
                                                    </th>
                                                </tr>
                                            </thead>
                                        </table>
                                    </div>
                                </div>
                            </div>
                            <!-- VERISON 1
                            <div class="col-xs-6 col-sm-6 col-md-6 col-lg-6 pr-4 pt-2">
                                <CFiltrosDeSecciones
                                    :conTitulo="false"
                                    :conEstilosClaros="true"
                                    :conAccionDeBusqueda="false"
                                    :escuchandoCambios="true"
                                    v-on:seModificoSeleccion="evtActaulizacionFiltrosDeSeccion"
                                    v-on:getSeccionParaPermisos="setSeccionParaPermisos"
                                    :key="secciones.filtros.KEY + secciones.filtros.contRender"></CFiltrosDeSecciones>
                            </div>
                            <div class="col-xs-6 col-sm-6 col-md-6 col-lg-6 pr-4 pt-2">
                                <div v-if="campoEsValido({ campoAValidar: this.secciones.filtros.seleccionada })" id="contenedor-tabla-areas" class="tabla-VADPI-intranet pr-4">
                                    <table
                                        class="table table-striped table-light table-hover"
                                        :id="tablaPuestosJuridicos.ID"              
                                        data-toggle="table"
                                        data-pagination="true"
                                        data-undefined-text="Sin información" 
                                        data-maintain-meta-data="true"
                                        data-click-to-select="true"
                                        data-page-size = "8"
                                        data-page-list="[5,10,20,30]"
                                        data-show-toggle="true"
                                        data-show-pagination-switch="true"
                                        data-search="true">
                                        <thead class="thead-dark">
                                            <tr>
                                                <th data-halign="center" data-width="10" data-align="center" data-field="seleccionado"  data-checkbox="true"></th>
                                                <th data-halign="center" data-width="10" data-align="center" data-field="PuestoJuridicoId" data-sortable="true">
                                                    Id
                                                </th>
                                                <th data-halign="center" data-width="80" data-align="center" data-field="Nombre" data-sortable="true">
                                                    Nombre de puesto
                                                </th>
                                            </tr>
                                        </thead>
                                    </table>
                                </div>
                            </div> -->
                        </div>
                        <!-- SECCION PARA PERMISOS POR PAGINA -->
                        <div v-if="this.CtiposDePermisos.valorDefinido == this.CtiposDePermisos.TIPOS.PAGINAS" id="caso-por-paginas" class="row no-gutters col-xs-12 col-sm-12 col-md-12 col-lg-12 pr-2 pt-2">
                            <div class="col-xs-6 col-sm-6 col-md-6 col-lg-6 pr-4 pt-2">
                                <div class="d-flex align-items-center flex-wrap pr-4" style="gap: 1em !important;">
                                    <h6><strong>(*) Selecciona una pagina</strong></h6>
                                    <C029PaginasDeIntranet class="flex-grow-1"
                                        v-on:valorParaElPadre="evtCambioTipoDePagina" 
                                        :prefijo="enumeraciones.etiquetasDeHTML.Select" 
                                        :tipo="enumeraciones.tiposDeSelect.Seleccione" 
                                        :idDelInput="CTipoDePagina.ID" 
                                        :parametros="CTipoDePagina.parametros" 
                                        :valorDefinido="CTipoDePagina.valorDefinido"
                                        :key="CTipoDePagina.key + CTipoDePagina.contRender"></C029PaginasDeIntranet>
                                </div>
                                <div v-if="campoEsValido({ campoAValidar: this.CTipoDePagina.seleccionada })" id="contenedor-tabla-areas" class="tabla-VADPI-intranet pr-4">
                                    <table
                                        class="table table-striped table-light table-hover"
                                        :id="tablaAreasIntranet.ID"              
                                        data-toggle="table"
                                        data-pagination="true"
                                        data-undefined-text="Sin información" 
                                        data-maintain-meta-data="true"
                                        data-click-to-select="true"
                                        data-page-size = "8"
                                        data-page-list="[5,10,20,30]"
                                        data-show-toggle="true"
                                        data-show-pagination-switch="true"
                                        data-search="true">
                                        <thead class="thead-dark">
                                            <tr>
                                                <th data-halign="center" data-width="10" data-align="center" data-field="seleccionado"  data-checkbox="true"></th>
                                                <th data-halign="center" data-width="10" data-align="center" data-field="AreaDeIntranetId" data-sortable="true">
                                                    Id
                                                </th>
                                                <th data-halign="center" data-width="80" data-align="center" data-field="Nombre" data-sortable="true">
                                                    Nombre de area
                                                </th>
                                            </tr>
                                        </thead>
                                    </table>
                                </div>
                            </div>
                            <div v-if="campoEsValido({ campoAValidar: this.CTipoDePagina.seleccionada })" class="col-xs-6 col-sm-6 col-md-6 col-lg-6 pr-4 pt-2">
                                <div class="lista-VADPI">
                                    <ul class="list-group">
                                        <li class="list-group-item disabled">
                                            <div class="form-inline justify-content-between flex-wrap">
                                                <h4><strong>Permisos [ {{ getNombreDePagina }} ]</strong></h4>
                                                <span class="badge bg-primary rounded-pill">{{ getPermisosDePaginaListado.length }}</span>
                                            </div>
                                        </li>
                                        <li v-if="!campoEsValido({ campoAValidar: getPermisosDePaginaListado })" class="list-group-item"><h4><strong>Ninguna area tiene permiso a esta pagina</strong></h4></li>
                                        <li v-for="(permiso) in getPermisosDePaginaListado" :key="permiso.AreaDeIntranetId" class="list-group-item">
                                            <div class="form-inline justify-content-between">
                                                <h6><i class="fas fa-key text-warning"></i>{{ ` .- Area [ ${ permiso.Nombre } ]` }}</h6>
                                            </div>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- MODAL CONFIRMACION -->
        <div class="modal align-middle" tabindex="-1" data-backdrop="static" data-keyboard="false"  id="modal-confirmar-cambio-seccion-VADPI">
            <div class="modal-dialog modal-lg">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Mensaje del sistema</h5>
                    </div>
                    <div class="modal-body pl-4 pr-4">
                        <div class="form-group">
                            <h6>
                                Se detectaron movimientos en la tabla de puestos juridicos,<br>
                                ¿Deseas guardar los cambios antes de cambiar de seccion?
                            </h6>
                        </div>
                        <div class="row mt-4">
                            <div class="col-6 pr-1 pl-1"><button type="button" class="btn btn-block btn-primary mr-2" @click="iniciarProcesoGuardarPermisosDeSeccion({ desdeModal: true })"><i class="fas fa-check"></i>&nbsp;&nbsp;Confirmar</button></div>
                            <div class="col-6 pr-1 pl-1"><button type="button" class="btn btn-block btn-primary" @click="evtCancelarModalConfirmacion"><i class="fas fa-times"></i>&nbsp;&nbsp;Cancelar</button></div>
                        </div>
                    </div>             
                </div>
            </div>
        </div>
        <!-- MODAL LISTA TEMPORAL DE PERMISOS -->
        <div class="modal align-middle" tabindex="-1" data-backdrop="static" data-keyboard="false"  id="modal-permisos-seccion-usuarios-VADPI">
            <div class="modal-dialog modal-lg">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Lista de permisos para guardar</h5>
                        <button  id="btn-cerrar-modal-permisos-seccion-usuarios-VADPI" class="close" data-dismiss="modal"><i class="fas fa-times-circle"></i></button>
                    </div>
                    <div class="modal-body" style="padding: 2em 2em 1em 2.5em !important;">
                        <div v-if="formularioUsuarios.tabla.lista.find(u => u.seleccionado) != null">
                            <div class="info-usuario form-inline justify-content-between">
                                <!-- <h5 class="form-inline"><i class="fas fa-user"></i>&nbsp;&nbsp;{{ formularioUsuarios.tabla.lista.find(u => u.seleccionado).Nombre }}</h5> -->
                                <h5 class="form-inline">Usuarios&nbsp;&nbsp;<span class="badge bg-primary rounded-pill">{{ formularioUsuarios.tabla.lista.filter(u => u.seleccionado).length }}</span></h5>
                                <button v-if="this.formularioUsuarios.tablaTemporalPermisos.lista.length > 0" type="button" class="btn btn-sm btn-info" @click="ejecutarProcesoNuevosPermisosUsuarioSecciones({ soloNuevos: true, usuariosId: formularioUsuarios.tabla.lista.filter(u => u.seleccionado).map(u => u.IdUsuario),  seccionesId: formularioUsuarios.tablaTemporalPermisos.lista.map(s => s.seccionId) })">
                                    <i class="fas fa-save"></i>&nbsp;&nbsp;Guardar
                                </button>
                            </div>
                        </div>
                        <div class="tabla-VADPI-intranet">
                            <div id="toolbar-tabla-permisos-temporal">
                                <div class="form-inline">
                                    <h6 class="pt-2"><strong>Secciones</strong></h6>
                                </div>
                            </div>
                            <table
                                class="table table-striped table-light table-hover"
                                :id="formularioUsuarios.tablaTemporalPermisos.ID"              
                                data-toggle="table"
                                data-pagination="true"
                                data-search-align="right"
                                 data-toolbar="#toolbar-tabla-permisos-temporal" 
                                data-toolbar-align="left"
                                data-undefined-text="Sin información" 
                                data-maintain-meta-data="true"
                                data-click-to-select="true"
                                data-page-size = "5"
                                data-page-list="[5,10,20,30]"
                                data-show-toggle="false"
                                data-show-pagination-switch="false"
                                data-search="true">
                                <thead class="thead-dark">
                                    <tr>
                                        <th data-halign="center" data-width="10" data-align="center" data-field="seccionId" data-sortable="true">
                                            Id
                                        </th>
                                        <th data-halign="center" data-width="40" data-align="center" data-field="nombre" data-sortable="true">
                                            Nombre
                                        </th>
                                        <th data-halign="center" data-width="40" data-align="center" data-field="perteneceA" data-sortable="true">
                                            Pertenece a
                                        </th>
                                        <th data-halign="center" data-width="10" data-align="center" data-events="operateEvents" data-field="eliminarHTML" data-sortable="true"></th>
                                    </tr>
                                </thead>
                            </table>
                        </div>
                    </div>           
                </div>
            </div>
        </div>
        <!-- MODAL EDICON DE SECCIONES USUARIO -->
        <div class="modal align-middle" tabindex="-1" data-backdrop="static" data-keyboard="false"  id="modal-edicion-secciones-usr-VADPI">
            <div class="modal-dialog modal-lg">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Lista de permisos con secciones de usuario</h5>
                        <button  id="btn-cerrar-modal-edicion-secciones-usr-VADPI" class="close" data-dismiss="modal"><i class="fas fa-times-circle"></i></button>
                    </div>
                    <div class="modal-body" style="padding: 2em 2em 1em 2.5em !important;">
                        <div class="tabla-VADPI-intranet">
                            <div id="toolbar-tabla-edicion-secciones-usr">
                                <div class="form-inline flex-wrap" style="gap: 1em !important;">
                                    <button type="button" class="btn btn-sm btn-info" @click="guardarCambiosSeccionesDeUsuario({ idModalDondeSeEjecuta: 'modal-edicion-secciones-usr-VADPI' })">
                                        <i class="fas fa-save"></i>&nbsp;&nbsp;Guardar
                                    </button>
                                    <button type="button" class="btn btn-sm btn-danger" @click="accionEnModal({ idModal: 'modal-edicion-secciones-usr-VADPI', mostrar: false}, accionEnModal({ idModal: 'modal-confirmar-remover-seccion-usr-VADPI', mostrar: true}))">
                                        <i class="fas fa-trash"></i>&nbsp;&nbsp;Remover todos
                                    </button>
                                </div>
                            </div>
                            <table
                                class="table table-striped table-light table-hover"
                                :id="formularioUsuarios.tablaSeccionesUsuario.ID"              
                                data-toggle="table"
                                data-pagination="true"
                                data-search-align="right"
                                 data-toolbar="#toolbar-tabla-edicion-secciones-usr" 
                                data-toolbar-align="left"
                                data-undefined-text="Sin información" 
                                data-maintain-meta-data="true"
                                data-click-to-select="true"
                                data-page-size = "5"
                                data-page-list="[5,10,20,30]"
                                data-show-toggle="false"
                                data-show-pagination-switch="false"
                                data-search="true">
                                <thead class="thead-dark">
                                    <tr>
                                        <th data-halign="center" data-width="10" data-align="center" data-field="seccionId" data-sortable="true">
                                            Id
                                        </th>
                                        <th data-halign="center" data-width="40" data-align="center" data-field="nombre" data-sortable="true">
                                            Nombre
                                        </th>
                                        <th data-halign="center" data-width="40" data-align="center" data-field="perteneceA" data-sortable="true">
                                            Pertenece a
                                        </th>
                                        <th data-halign="center" data-width="10" data-align="center" data-events="operateEvents" data-field="eliminarHTML" data-sortable="true"></th>
                                    </tr>
                                </thead>
                            </table>
                        </div>
                    </div>           
                </div>
            </div>
        </div>
        <!-- MODAL CONFRIMAR QUITAR TODAS LAS SECCIONES A USUARIO -->
        <div class="modal align-middle" tabindex="-1" data-backdrop="static" data-keyboard="false"  id="modal-confirmar-remover-seccion-usr-VADPI">
            <div class="modal-dialog modal-lg">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Mensaje del sistema</h5>
                    </div>
                    <div class="modal-body pl-4 pr-4">
                        <div class="form-group">
                            <h6>
                                Se eliminaran todas los permisos especiales del usuario con las secciones de intranet,<br>
                                ¿Deseas continuar?
                            </h6>
                        </div>
                        <div class="row mt-4">
                            <div class="col-6 pr-1 pl-1"><button type="button" class="btn btn-block btn-primary mr-2" @click="guardarCambiosSeccionesDeUsuario({ idModalDondeSeEjecuta: 'modal-confirmar-remover-seccion-usr-VADPI', eliminarTodos: true })"><i class="fas fa-check"></i>&nbsp;&nbsp;Confirmar</button></div>
                            <div class="col-6 pr-1 pl-1"><button type="button" class="btn btn-block btn-primary" @click="accionEnModal({ idModal: 'modal-confirmar-remover-seccion-usr-VADPI', mostrar: false}), accionEnModal({ idModal: 'modal-edicion-secciones-usr-VADPI', mostrar: true})"><i class="fas fa-times"></i>&nbsp;&nbsp;Cancelar</button></div>
                        </div>
                    </div>             
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import sistemas from '@/../static/js/sistemas'
import enumeraciones from '@/../static/js/enumeraciones'
import catalogos from '@/../static/js/catalogos'
import { campoEsValido, convertirCadenaAMayusculas } from "../../../SINOJ/Comun/Funciones/validaciones.js"
import axios from 'axios';
import api from '@/../static/js/api';
import comun from '@/../static/js/comun';
import CFiltrosDeSecciones from '@/components/SICPO/Intranet/Contenidos/CFiltrosDeBusqueda.vue';

export default {
    components: {
        CCatalogoGenerico: sistemas.SINOJ.CCatalogoGenerico,
        C030AreasDeIntranet: catalogos.SICPO.C030AreasDeIntranet,
        C029PaginasDeIntranet: catalogos.SICPO.C029PaginasDeIntranet,
        CFiltrosDeSecciones: CFiltrosDeSecciones
    },
    data() {
        return {
            enumeraciones,
            campoEsValido,
            convertirCadenaAMayusculas,
            CtiposDePermisos: {
                TIPOS: { PAGINAS: 1, SECCIONES: 2 },
                ID: 'CTiposDePermisos_VADPI',
                KEY: 'KEY_TiposDePermisos_VADPI',
                valorDefinido: 2,
                opciones: [ { llave: 1, valor: 'permisos para paginas' }, { llave: 2, valor: 'permisos para secciones de intranet' } ],
                mostrarSoloOpcionesValidas: false,
                contRender: 0,
                seleccionado: { llave: 2, valor: 'permisos para secciones de intranet' }
            },
            CTipoDePagina: {
                ID: 'CPaginaIntranet_VADPI',
                KEY: 'KPaginaIntranet_VADPI',
                parametros: {
                    PaginaDeInicioId: null,
                    MenuId: null,
                    SubmenuId: null,
                    RutaDeAccesoDeLaPagina: null,
                    Titulo: null,
                    Activo: true,
                    ConAreasDeIntranet: true,
                    ConPaginaDeInicio: false,
                    ConMenu: false,
                    ConSubmenu: false,
                    ConSecciones: false,
                    areaDeIntranetId: null
                },
                valorDefinido: -1,
                contRender: 0,
                seleccionada: null
            },
            tablaAreasIntranet: {
                ID: 'TAreasIntranet_VADPI',
                listaDB: [],
                lista: []
            },
            secciones: {
                filtros: {
                    KEY: 'CFiltrosSecciones_VADPI',
                    contRender: 0,
                    seleccionada: null
                }
            },
            tablaPuestosJuridicos: {
                ID: 'TPuestosJuridicos_VADPI',
                listaDB: [],
                lista: [],
                seRealizaronMovimientos: false
            },
            formularioUsuarios: {
                nombre: null,
                apellidoPaterno: null,
                apellidoMaterno: null,
                correo: null,
                mostrarFiltrosBusqueda: true,
                tabla: {
                    visible: false,
                    ID: 'TPUsuarios_VADPI',
                    lista: []
                },
                CAreas: {
                    id: 'CTiposDeAreas_VADPI',
                    key: 'KTiposDeAreas_VADPI',
                    parametros: {
                        Nombre: null,
                        ConAreasDePJ: true,
                        ConPaginas: false
                    },
                    areaId: -1,
                    contRender: 0,
                    seleccionada: null
                },
                CPaginas: {
                    id: 'CTiposDePaginas_VADPI',
                    key: 'KTiposDePaginas_VADPI',
                    parametros: {
                        PaginaDeInicioId: null,
                        MenuId: null,
                        SubmenuId: null,
                        RutaDeAccesoDeLaPagina: null,
                        Titulo: null,
                        Activo: true,
                        ConAreasDeIntranet: false,
                        ConPaginaDeInicio: false,
                        ConMenu: false,
                        ConSubmenu: false,
                        ConSecciones: false,
                        areaDeIntranetId: null
                    },
                    paginaId: -1,
                    contRender: 0,
                    seleccionada: null
                },
                tablaSecciones: {
                    ID: 'IDTSecciones_VADPI',
                    lista: [],
                    visible: false
                },
                tablaTemporalPermisos: {
                    ID: 'IDTTemporalPermisosSeccionesUsuarios_VADPI',
                    lista: [], 
                },
                tablaSeccionesUsuario: {
                    ID: 'IDTSeccionesDeUsuario_VADPI',
                    lista: [],
                    seleccionado: null
                }
            },
        }
    },
    methods: {
        guardarCambiosSeccionesDeUsuario: function({ idModalDondeSeEjecuta, eliminarTodos = false }) {
            this.accionEnModal({ 
                idModal: idModalDondeSeEjecuta, 
                mostrar: false
            });
            this.ejecutarProcesoNuevosPermisosUsuarioSecciones({ 
                soloNuevos: false, 
                usuariosId: [this.formularioUsuarios.tablaSeccionesUsuario.seleccionado.IdUsuario], 
                seccionesId: eliminarTodos ? [] : this.formularioUsuarios.tablaSeccionesUsuario.lista.map(s => s.seccionId) 
            });
        },
        ejectuarProcesoGetSeccionesUsuario: async function({ usuario }) {
            try {
                // se crea la peticion para guardar los nuevos permisos entre secciones y usuarios
                const P_GET_SECCIONES = {
                    UsuarioId: usuario.IdUsuario,
                    EsPrueba: false
                };

                // se llama al servicio para guardar los permisos
                const { conError, secciones } = await Promise.resolve(this.getSeccionesDeUsuarioDB({ peticion: P_GET_SECCIONES }));
                if(!conError) {
                    if(!campoEsValido({ campoAValidar: secciones })) {
                        comun.mensajeDeAlerta('El usuario no tiene ningun permiso especial con alguna de las secciones de intranet');
                    }
                    else {
                        // se actualizan las filas de los usuarios modificados
                        this.formularioUsuarios.tablaSeccionesUsuario.lista = secciones.map(sDB => {
                            let seccionObj = { ...sDB };
                            seccionObj.eliminarHTML = `<button type="button" title="eliminar seccion de la lista" class="btn btn-sm btn-removerSeccionDeUsuario-VADPI btn-danger">
                                                            <i class="fas fa-trash"></i>
                                                        </button>`
                            return seccionObj;
                        });
                        this.accionEnModal({ 
                            idModal: 'modal-edicion-secciones-usr-VADPI', 
                            mostrar: true, cargarTabla : { idTabla: this.formularioUsuarios.tablaSeccionesUsuario.ID, elementos: this.formularioUsuarios.tablaSeccionesUsuario.lista } 
                        });
                    }
                }
            }
            catch(error) {
                console.error();
            }
        },
        getSeccionesDeUsuarioDB: async function({ peticion, visualizarCargaDeInformacion = true }) { 
            let proceso = { conError: true, secciones: [] };
            try {
                const SERVIDOR = api.conexion;
                const METODO_API_GUARDAR = api.SICPO.sistema.intranet.administracionDePermisos.ObtenerSeccionesDeUsuario;
                let urlApi = SERVIDOR + METODO_API_GUARDAR;
                let peticionAPI = peticion;
                const HEADER_PARA_ENVIO_ARCHIVOS = false;
                const HEADER_PARA_ARRAY_BUFFER = false;
                let headerPeticion = comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal, HEADER_PARA_ENVIO_ARCHIVOS,HEADER_PARA_ARRAY_BUFFER);
                if(visualizarCargaDeInformacion)
                    comun.SeEstaCargandoInformacion(true);
                const RESPUESTA_SOLICITUD = await axios.post(urlApi, peticionAPI, headerPeticion);
                const DATOS_RESPUESTA = await RESPUESTA_SOLICITUD.data;
                let { SiHayError, Error, Secciones } = DATOS_RESPUESTA;
                if (SiHayError) {
                    let mensajeError = Error.Mensaje;
                    console.log(Error);
                    if(visualizarCargaDeInformacion)
                        comun.SeEstaCargandoInformacion(false);
                    comun.mensajeDeAlerta(mensajeError);
                } 
                else { 
                    proceso.secciones = campoEsValido({ campoAValidar: Secciones }) ? Secciones : [];
                    proceso.conError = false;
                }
                if(visualizarCargaDeInformacion)
                    comun.SeEstaCargandoInformacion(false);
            }
            catch(excepcion) {
                console.log(excepcion);
                comun.SeEstaCargandoInformacion(false);
                comun.mensajeDeAlerta(enumeraciones.error.E500, null, null);
            }
            return proceso;
        },
        ejecutarProcesoGuardarPermisosAPlataformaIntranet: async function({ usuarios, activar }) {
            try {
                // se crea la peticion para guardar los nuevos permisos entre secciones y usuarios
                const P_GUARDAR_PERMISOS = {
                    UsuariosId: usuarios,
                    Activar: activar,
                    EsPrueba: false
                };

                // se llama al servicio para guardar los permisos
                const { conError } = await Promise.resolve(this.guardarPermisosAPlataformaIntranetDB({ peticion: P_GUARDAR_PERMISOS }));
                if(!conError) {
                    // se actualizan las filas de los usuarios modificados
                    usuarios.forEach(idUsuario => { debugger
                        let usuarioActualizado = this.formularioUsuarios.tabla.lista.find(u => u.IdUsuario == idUsuario);
                        usuarioActualizado.TienePermisosEnIntranet = activar;
                        usuarioActualizado.habilitado = usuarioActualizado.TienePermisosEnIntranet;
                        usuarioActualizado.accionHTML = (!usuarioActualizado.TienePermisosEnIntranet) 
                            ? `<button type="button" title="Dar permiso a plataforma de intranet" class="btn btn-sm btn-usr-agregarAIntranet-VADPI btn-success">
                                 <i class="fas fa-plus"></i>
                               </button>`
                            : `<div class="d-flex flex-wrap justify-content-center" style="gap: 1em !important;">
                                    <button type="button" title="Editar permisos con secciones plataforma de intranet" class="btn btn-sm btn-usr-verPermisosSecciones-VADPI btn-warning">
                                        <i class="fas fa-key"></i>
                                    </button>
                                    <button type="button" title="remover permiso a plataforma de intranet" class="btn btn-sm btn-usr-removerIntranet-VADPI btn-danger">
                                        <i class="fas fa-trash"></i>
                                    </button>
                               </div>`;
                        $("#" + this.formularioUsuarios.tabla.ID).bootstrapTable('updateByUniqueId', {
                            id: usuarioActualizado.IdUsuario,
                            row: usuarioActualizado
                        });
                    })
                }
            }
            catch(error) {
                console.error();
            }
        },
        guardarPermisosAPlataformaIntranetDB: async function({ peticion, visualizarCargaDeInformacion = true }) { debugger
            let proceso = { conError: true };
            try {
                const SERVIDOR = api.conexion;
                const METODO_API_GUARDAR = api.SICPO.sistema.intranet.administracionDePermisos.GuardarPermisosAPlataformaIntranet;
                let urlApi = SERVIDOR + METODO_API_GUARDAR;
                let peticionAPI = peticion;
                const HEADER_PARA_ENVIO_ARCHIVOS = false;
                const HEADER_PARA_ARRAY_BUFFER = false;
                let headerPeticion = comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal, HEADER_PARA_ENVIO_ARCHIVOS,HEADER_PARA_ARRAY_BUFFER);
                if(visualizarCargaDeInformacion)
                    comun.SeEstaCargandoInformacion(true);
                const RESPUESTA_SOLICITUD = await axios.post(urlApi, peticionAPI, headerPeticion);
                const DATOS_RESPUESTA = await RESPUESTA_SOLICITUD.data;
                let { SiHayError, Error, Satisfactorio } = DATOS_RESPUESTA;
                if (SiHayError) {
                    let mensajeError = Error.Mensaje;
                    console.log(Error);
                    if(visualizarCargaDeInformacion)
                        comun.SeEstaCargandoInformacion(false);
                    comun.mensajeDeAlerta(mensajeError);
                } 
                else { 
                    proceso.conError = false;
                    comun.mensajeDeAlerta(Satisfactorio)
                }
                if(visualizarCargaDeInformacion)
                    comun.SeEstaCargandoInformacion(false);
            }
            catch(excepcion) {
                console.log(excepcion);
                comun.SeEstaCargandoInformacion(false);
                comun.mensajeDeAlerta(enumeraciones.error.E500, null, null);
            }
            return proceso;
        },
        ejecutarProcesoNuevosPermisosUsuarioSecciones: async function({ soloNuevos, usuariosId, seccionesId }) {
            try {
                if(soloNuevos) {
                    this.accionEnModal({ idModal: 'modal-permisos-seccion-usuarios-VADPI', mostrar: false })
                }
                // se crea la peticion para guardar los nuevos permisos entre secciones y usuarios
                const P_GUARDAR_PERMISOS = {
                    IdSecciones: seccionesId,
                    SoloNuevos: soloNuevos,
                    UsuariosId: usuariosId,
                    EsPrueba: false
                };

                // se llama al servicio para guardar los permisos
                const { conError, permisos } = await Promise.resolve(this.guardarPermisosSeccionesUsuariosDB({ peticion: P_GUARDAR_PERMISOS }));
                if(!conError) {
                    this.formularioUsuarios.tablaTemporalPermisos.lista = [];
                }
                else {
                    if(soloNuevos) {
                        this.accionEnModal({ idModal: 'modal-permisos-seccion-usuarios-VADPI', mostrar: true })
                    }
                }
            }
            catch(error) {
                console.error();
            }
        },
        guardarPermisosSeccionesUsuariosDB: async function({ peticion, visualizarCargaDeInformacion = true }) { 
            let proceso = { conError: true, permisos: [] };
            try {
                const SERVIDOR = api.conexion;
                const METODO_API_GUARDAR = api.SICPO.sistema.intranet.administracionDePermisos.GuardarSeccionesUsuarios;
                let urlApi = SERVIDOR + METODO_API_GUARDAR;
                let peticionAPI = peticion;
                const HEADER_PARA_ENVIO_ARCHIVOS = false;
                const HEADER_PARA_ARRAY_BUFFER = false;
                let headerPeticion = comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal, HEADER_PARA_ENVIO_ARCHIVOS,HEADER_PARA_ARRAY_BUFFER);
                if(visualizarCargaDeInformacion)
                    comun.SeEstaCargandoInformacion(true);
                const RESPUESTA_SOLICITUD = await axios.post(urlApi, peticionAPI, headerPeticion);
                const DATOS_RESPUESTA = await RESPUESTA_SOLICITUD.data;
                let { SiHayError, Error, IdSecciones, UsuarioId, Satisfactorio } = DATOS_RESPUESTA;
                if (SiHayError) {
                    let mensajeError = Error.Mensaje;
                    console.log(Error);
                    if(visualizarCargaDeInformacion)
                        comun.SeEstaCargandoInformacion(false);
                    comun.mensajeDeAlerta(mensajeError);
                } 
                else { 
                    proceso.permisos = campoEsValido({ campoAValidar: IdSecciones }) ? IdSecciones : [];
                    proceso.conError = false;
                    comun.mensajeDeAlerta(Satisfactorio)
                }
                if(visualizarCargaDeInformacion)
                    comun.SeEstaCargandoInformacion(false);
            }
            catch(excepcion) {
                console.log(excepcion);
                comun.SeEstaCargandoInformacion(false);
                comun.mensajeDeAlerta(enumeraciones.error.E500, null, null);
            }
            return proceso;
        },
        removerElementoDeLista: function({ idTabla, elemento, eliminarPor }) {
            $("#" + idTabla).bootstrapTable('remove', {
                field: eliminarPor,
                values: [elemento[eliminarPor]]
            });
        },
        accionEnModal: async function({ idModal, mostrar, cargarTabla = { idTabla: '', elementos: [] }}) {
            let instruccion = mostrar ? 'show' : 'hide';
            $("#" + idModal).modal(instruccion);

            if(campoEsValido({ campoAValidar: cargarTabla.idTabla })) {
                await Promise.resolve(this.inicializarTabla({ idReferencia: cargarTabla.idTabla, elementos: cargarTabla.elementos }));
            }
        },
        agregarSeccionListaTemporalPermisos: function() {
            // se agregan las secciones seleccionadas a la lista temporal de permisos
            let agregoUnaSeccion = 0;
            this.formularioUsuarios.tablaSecciones.lista.filter(s => s.seleccionado).forEach(seccion => {
                let seccionYaFueAgregada = this.formularioUsuarios.tablaTemporalPermisos.lista.some(seccionTmp => seccionTmp.seccionId == seccion.seccionId);
                if(!seccionYaFueAgregada) {
                    let seccionObj = { ...seccion };
                    seccionObj.eliminarHTML = `<button type="button" title="eliminar seccion de la lista" class="btn btn-sm btn-removerSeccion-VADPI btn-danger">
                                                    <i class="fas fa-trash"></i>
                                               </button>`
                    this.formularioUsuarios.tablaTemporalPermisos.lista.push(seccionObj);
                    agregoUnaSeccion ++;
                }
            });

            if(agregoUnaSeccion > 0) {
                comun.mensajeDeAlerta(`l${ (agregoUnaSeccion > 1) ? 'as' : 'a' } seccion${ (agregoUnaSeccion > 1) ? 'es' : '' } se agregaron a la lista temporal de permisos`)
            }
            else {
                comun.mensajeDeAlerta('Las secciones seleccionadas ya fueron agrgadas anteriormente en la lista temporal de permisos')
            }
        },
        ejecutarProcesoBusquedaDeSecciones: async function() {
            try {
                // se crea la peticion de busqueda
                const { paginaId } = this.formularioUsuarios.CPaginas;
                const P_GET_SECCIONES = {
                    PaginaId: paginaId,
                    EsPrueba: false
                };

                // se llama al servicio de busqueda y se mapea la infromacion de las secciones
                const { conError, secciones } = await Promise.resolve(this.getSeccionesDB({ peticion: P_GET_SECCIONES }));
                console.log('sECCIONESSSSS::',secciones)
                if(!conError) {
                    const { ID } = this.formularioUsuarios.tablaSecciones;
                    this.formularioUsuarios.tablaSecciones.lista = campoEsValido({ campoAValidar: secciones }) 
                    ? secciones.map(sDB => {
                        let seccionObj = { ...sDB };
                        seccionObj.seleccionado = false;
                        return seccionObj;
                    }) : [];
                    this.formularioUsuarios.tablaSecciones.visible = true;
                    await Promise.resolve(this.inicializarTabla({ idReferencia: ID, elementos: this.formularioUsuarios.tablaSecciones.lista }));
                }
                else {
                    comun.mensajeDeAlerta('Ocurrio un error al buscar las secciones');
                }
            }
            catch(error) {
                console.error();
                comun.mensajeDeAlerta('Ocurrio un error al buscar las secciones');
            }
        },
        getSeccionesDB: async function({ peticion, visualizarCargaDeInformacion = true }) { 
            let proceso = { conError: true, secciones: [] };
            try {
                const SERVIDOR = api.conexion;
                const METODO_API_OBTENER = api.SICPO.sistema.intranet.administracionDePermisos.ObtenerSecciones;
                let urlApi = SERVIDOR + METODO_API_OBTENER;
                let peticionAPI = peticion;
                const HEADER_PARA_ENVIO_ARCHIVOS = false;
                const HEADER_PARA_ARRAY_BUFFER = false;
                let headerPeticion = comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal, HEADER_PARA_ENVIO_ARCHIVOS,HEADER_PARA_ARRAY_BUFFER);
                if(visualizarCargaDeInformacion)
                    comun.SeEstaCargandoInformacion(true);
                const RESPUESTA_SOLICITUD = await axios.post(urlApi, peticionAPI, headerPeticion);
                const DATOS_RESPUESTA = await RESPUESTA_SOLICITUD.data;
                let { SiHayError, Error, Secciones } = DATOS_RESPUESTA;
                if (SiHayError) {
                    let mensajeError = Error.Mensaje;
                    console.log(Error);
                    if(visualizarCargaDeInformacion)
                        comun.SeEstaCargandoInformacion(false);
                    comun.mensajeDeAlerta(mensajeError);
                } 
                else { 
                    proceso.secciones = campoEsValido({ campoAValidar: Secciones }) ? Secciones : [];
                    proceso.conError = false;
                }
                if(visualizarCargaDeInformacion)
                    comun.SeEstaCargandoInformacion(false);
            }
            catch(excepcion) {
                console.log(excepcion);
                comun.SeEstaCargandoInformacion(false);
                comun.mensajeDeAlerta(enumeraciones.error.E500, null, null);
            }
            return proceso;
        },
        evtCambioTipoPagina: function(evento) {
            this.formularioUsuarios.CPaginas.paginaId = parseInt(evento.target.value);
        },
        evtCambioTipoArea: function(evento) {
            this.formularioUsuarios.CAreas.areaId = parseInt(evento.target.value);

            // limpia los valores del catalgo de paginas
            this.formularioUsuarios.CPaginas.paginaId = -1;
            this.formularioUsuarios.CPaginas.parametros.areaDeIntranetId = campoEsValido({ campoAValidar: this.formularioUsuarios.CAreas.areaId }) ? this.formularioUsuarios.CAreas.areaId : null;
            this.formularioUsuarios.CPaginas.contRender ++;
        },
        ejecutarProcesoBusquedaDeUsuarios: async function(evento) {
            evento.preventDefault();
            try {
                // se crea la peticion de busqueda
                const { nombre, apellidoPaterno, apellidoMaterno, correo } = this.formularioUsuarios;
                const P_GET_USUARIOS = {
                    Nombre: campoEsValido({ campoAValidar: nombre }) ? nombre : null,
                    ApellidoPaterno: campoEsValido({ campoAValidar: apellidoPaterno }) ? apellidoPaterno : null,
                    ApellidoMaterno: campoEsValido({ campoAValidar: apellidoMaterno }) ? apellidoMaterno : null,
                    Correo: campoEsValido({ campoAValidar: correo }) ? correo : null,
                    EsPrueba: false
                };

                // se llama al servicio de busqueda y se mapea la infromacion de los usuarios
                const { conError, usuarios } = await Promise.resolve(this.getUsuariosDB({ peticion: P_GET_USUARIOS }));
                console.log('Uusariossss::',usuarios)
                if(!conError) {
                    const { ID } = this.formularioUsuarios.tabla;
                    this.formularioUsuarios.tabla.lista = campoEsValido({ campoAValidar: usuarios }) 
                    ? usuarios.map(uDB => {
                        let usuarioObj = { ...uDB };
                        usuarioObj.seleccionado = (usuarios.length == 1);
                        usuarioObj.habilitado = uDB.TienePermisosEnIntranet;
                        usuarioObj.accionHTML = (!uDB.TienePermisosEnIntranet) 
                            ? `<button type="button" title="Dar permiso a plataforma de intranet" class="btn btn-sm btn-usr-agregarAIntranet-VADPI btn-success">
                                 <i class="fas fa-plus"></i>
                               </button>`
                            : `<div class="d-flex flex-wrap justify-content-center" style="gap: 1em !important;">
                                    <button type="button" title="Editar permisos con secciones plataforma de intranet" class="btn btn-sm btn-usr-verPermisosSecciones-VADPI btn-warning">
                                        <i class="fas fa-key"></i>
                                    </button>
                                    <button type="button" title="remover permiso a plataforma de intranet" class="btn btn-sm btn-usr-removerIntranet-VADPI btn-danger">
                                        <i class="fas fa-trash"></i>
                                    </button>
                               </div>`;
                        return usuarioObj;
                    }) : [];
                    this.formularioUsuarios.tabla.visible = true;
                    await Promise.resolve(this.inicializarTabla({ idReferencia: ID, elementos: this.formularioUsuarios.tabla.lista }));
                    this.formularioUsuarios.mostrarFiltrosBusqueda = false;
                }
                else {
                    comun.mensajeDeAlerta('Ocurrio un error al buscar los usuarios');
                }
            }
            catch(error) {
                console.error();
                comun.mensajeDeAlerta('Ocurrio un error al realizar la busqueda');
            }
        },
        getUsuariosDB: async function({ peticion, visualizarCargaDeInformacion = true }) { 
            let proceso = { conError: true, usuarios: [] };
            try {
                const SERVIDOR = api.conexion;
                const METODO_API_OBTENER = api.SICPO.sistema.intranet.administracionDePermisos.ObtenerUsuarios;
                let urlApi = SERVIDOR + METODO_API_OBTENER;
                let peticionAPI = peticion;
                const HEADER_PARA_ENVIO_ARCHIVOS = false;
                const HEADER_PARA_ARRAY_BUFFER = false;
                let headerPeticion = comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal, HEADER_PARA_ENVIO_ARCHIVOS,HEADER_PARA_ARRAY_BUFFER);
                if(visualizarCargaDeInformacion)
                    comun.SeEstaCargandoInformacion(true);
                const RESPUESTA_SOLICITUD = await axios.post(urlApi, peticionAPI, headerPeticion);
                const DATOS_RESPUESTA = await RESPUESTA_SOLICITUD.data;
                let { SiHayError, Error, Usuarios } = DATOS_RESPUESTA;
                if (SiHayError) {
                    let mensajeError = Error.Mensaje;
                    console.log(Error);
                    if(visualizarCargaDeInformacion)
                        comun.SeEstaCargandoInformacion(false);
                    comun.mensajeDeAlerta(mensajeError);
                } 
                else { 
                    proceso.usuarios = campoEsValido({ campoAValidar: Usuarios }) ? Usuarios : [];
                    proceso.conError = false;
                }
                if(visualizarCargaDeInformacion)
                    comun.SeEstaCargandoInformacion(false);
            }
            catch(excepcion) {
                console.log(excepcion);
                comun.SeEstaCargandoInformacion(false);
                comun.mensajeDeAlerta(enumeraciones.error.E500, null, null);
            }
            return proceso;
        },
        evtBusquedaUsuario: function(evento) {
            evento.preventDefault();
            alert('funciona');
        },
        evtCancelarModalConfirmacion: function() {
            $('#modal-confirmar-cambio-seccion-VADPI').modal('hide'); 
            this.tablaPuestosJuridicos.seRealizaronMovimientos = false; 
            this.tablaPuestosJuridicos.lista = []; 
            this.secciones.filtros.seleccionada = null;
        },
        evtActaulizacionFiltrosDeSeccion: function() {
            const { seRealizaronMovimientos } = this.tablaPuestosJuridicos;
            if(seRealizaronMovimientos) {
                $('#modal-confirmar-cambio-seccion-VADPI').modal('show')
            }
            else {
                this.tablaPuestosJuridicos.lista = [];
                this.secciones.filtros.seleccionada = null;
            }
        },
        setSeccionParaPermisos: async function(seccionObj) {
            this.secciones.filtros.seleccionada = seccionObj;
            if(campoEsValido({ campoAValidar: seccionObj })) {
                const { puestos } = await Promise.resolve(this.getPermisosDeSeccionDB({ peticion: { EsPrueba: false, SeccionId: seccionObj.SeccionDeIntranetId  } }));
                this.secciones.filtros.seleccionada.PuestosJuridicos = puestos;
            }
            await await Promise.resolve(this.cargarInformacionTablaPuestos());
            console.log('seccionObj::',seccionObj);
        },
        getPermisosDeSeccionDB: async function({ peticion, visualizarCargaDeInformacion = true }) { 
            let proceso = { conError: true, puestos: [] };
            try {
                const SERVIDOR = api.conexion;
                const METODO_API_OBTENER = api.SICPO.sistema.intranet.administracionDePermisos.ObtenerPermisosDeSeccion;
                let urlApi = SERVIDOR + METODO_API_OBTENER;
                let peticionAPI = peticion;
                const HEADER_PARA_ENVIO_ARCHIVOS = false;
                const HEADER_PARA_ARRAY_BUFFER = false;
                let headerPeticion = comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal, HEADER_PARA_ENVIO_ARCHIVOS,HEADER_PARA_ARRAY_BUFFER);
                if(visualizarCargaDeInformacion)
                    comun.SeEstaCargandoInformacion(true);
                const RESPUESTA_SOLICITUD = await axios.post(urlApi, peticionAPI, headerPeticion);
                const DATOS_RESPUESTA = await RESPUESTA_SOLICITUD.data;
                let { SiHayError, Error, Puestos } = DATOS_RESPUESTA;
                if (SiHayError) {
                    let mensajeError = Error.Mensaje;
                    console.log(Error);
                    if(visualizarCargaDeInformacion)
                        comun.SeEstaCargandoInformacion(false);
                    comun.mensajeDeAlerta(mensajeError);
                } 
                else { 
                    proceso.puestos = campoEsValido({ campoAValidar: Puestos }) ? Puestos : [];
                    proceso.conError = false;
                }
                if(visualizarCargaDeInformacion)
                    comun.SeEstaCargandoInformacion(false);
            }
            catch(excepcion) {
                console.log(excepcion);
                comun.SeEstaCargandoInformacion(false);
                comun.mensajeDeAlerta(enumeraciones.error.E500, null, null);
            }
            return proceso;
        },
        iniciarProcesoGuardarPermisosDePagina: async function() {
            const { seleccionada, valorDefinido } = this.CTipoDePagina;
            if(campoEsValido({ campoAValidar: seleccionada })) {
                comun.SeEstaCargandoInformacion(true);
                const { lista } = this.tablaAreasIntranet;
                const AREAS_SELECCIONADAS = lista.filter(a => a.seleccionado);
                // se crea la peticion para guardar los permisos de la pagina
                const PETICION_GUARDAR_PERMISOS = {
                    PaginaId: valorDefinido,
                    Areas: campoEsValido({ campoAValidar: AREAS_SELECCIONADAS }) ? AREAS_SELECCIONADAS.map(a => a.AreaDeIntranetId) : [],
                    EsPrueba: false
                }

                // se guardan los permisos en base de datos
                const { conError, areasConPermisos } = await Promise.resolve(this.guardarPermisosDePaginaDB({ peticion: PETICION_GUARDAR_PERMISOS, visualizarCargaDeInformacion: false }));
                comun.SeEstaCargandoInformacion(false);
            }
            else {
                comun.mensajeDeAlerta('Debes seleccionar una pagina valida');
            }
        },
        iniciarProcesoGuardarPermisosDeSeccion: async function({ desdeModal }) {
            $('#modal-confirmar-cambio-seccion-VADPI').modal('hide'); 
            this.tablaPuestosJuridicos.seRealizaronMovimientos = false;
            const { seleccionada } = this.secciones.filtros;
            if(campoEsValido({ campoAValidar: seleccionada })) {
                comun.SeEstaCargandoInformacion(true);
                const { lista } = this.tablaPuestosJuridicos;
                const PUESTOS_SELECCIONADOS = lista.filter(p => p.seleccionado);
                console.log();
                // se crea la peticion para guardar los permisos de la seccion
                const PETICION_GUARDAR_PERMISOS = {
                    SeccionId: seleccionada.SeccionDeIntranetId,
                    Puestos: campoEsValido({ campoAValidar: PUESTOS_SELECCIONADOS }) ? PUESTOS_SELECCIONADOS.map(p => p.PuestoJuridicoId) : [],
                    EsPrueba: false
                }

                // se guardan los permisos en base de datos
                const { conError, puestosConPermisos } = await Promise.resolve(this.guardarPermisosDeSeccionDB({ peticion: PETICION_GUARDAR_PERMISOS, visualizarCargaDeInformacion: false }));
                comun.SeEstaCargandoInformacion(false);
            }
            else {
                comun.mensajeDeAlerta('Debes seleccionar una seccion valida');
            }

            if(desdeModal) {
                this.tablaPuestosJuridicos.lista = [];
                this.secciones.filtros.seleccionada = null;
            }
        },
        guardarPermisosDeSeccionDB: async function({ peticion, visualizarCargaDeInformacion = true }) { 
            let procesoGuardado = { conError: true, puestosConPermisos: [] };
            try {
                const SERVIDOR = api.conexion;
                const METODO_API_GUARDAR = api.SICPO.sistema.intranet.administracionDePermisos.GuardarPermisosDeSeccion;
                let urlApi = SERVIDOR + METODO_API_GUARDAR;
                let peticionAPI = peticion;
                const HEADER_PARA_ENVIO_ARCHIVOS = false;
                const HEADER_PARA_ARRAY_BUFFER = false;
                let headerPeticion = comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal, HEADER_PARA_ENVIO_ARCHIVOS,HEADER_PARA_ARRAY_BUFFER);
                if(visualizarCargaDeInformacion)
                    comun.SeEstaCargandoInformacion(true);
                const RESPUESTA_SOLICITUD = await axios.post(urlApi, peticionAPI, headerPeticion);
                const DATOS_RESPUESTA = await RESPUESTA_SOLICITUD.data;
                let { SiHayError, Error, Puestos, Satisfactorio } = DATOS_RESPUESTA;
                if (SiHayError) {
                    let mensajeError = Error.Mensaje;
                    console.log(Error);
                    if(visualizarCargaDeInformacion)
                        comun.SeEstaCargandoInformacion(false);
                    comun.mensajeDeAlerta(mensajeError);
                } 
                else { 
                    procesoGuardado.conError = false;
                    procesoGuardado.puestosConPermisos = campoEsValido({ campoAValidar: Puestos }) ? Puestos : [];
                    comun.mensajeDeAlerta(Satisfactorio);
                }
                if(visualizarCargaDeInformacion)
                    comun.SeEstaCargandoInformacion(false);
            }
            catch(excepcion) {
                console.log(excepcion);
                comun.SeEstaCargandoInformacion(false);
                comun.mensajeDeAlerta(enumeraciones.error.E500, null, null);
            }
            return procesoGuardado;
        },
        guardarPermisosDePaginaDB: async function({ peticion, visualizarCargaDeInformacion = true }) { 
            let procesoGuardado = { conError: true, areasConPermisos: [] };
            try {
                const SERVIDOR = api.conexion;
                const METODO_API_GUARDAR = api.SICPO.sistema.intranet.administracionDePermisos.GuardarPermisosDePagina;
                let urlApi = SERVIDOR + METODO_API_GUARDAR;
                let peticionAPI = peticion;
                const HEADER_PARA_ENVIO_ARCHIVOS = false;
                const HEADER_PARA_ARRAY_BUFFER = false;
                let headerPeticion = comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal, HEADER_PARA_ENVIO_ARCHIVOS,HEADER_PARA_ARRAY_BUFFER);
                if(visualizarCargaDeInformacion)
                    comun.SeEstaCargandoInformacion(true);
                const RESPUESTA_SOLICITUD = await axios.post(urlApi, peticionAPI, headerPeticion);
                const DATOS_RESPUESTA = await RESPUESTA_SOLICITUD.data;
                let { SiHayError, Error, Areas, Satisfactorio } = DATOS_RESPUESTA;
                if (SiHayError) {
                    let mensajeError = Error.Mensaje;
                    console.log(Error);
                    if(visualizarCargaDeInformacion)
                        comun.SeEstaCargandoInformacion(false);
                    comun.mensajeDeAlerta(mensajeError);
                } 
                else { 
                    procesoGuardado.conError = false;
                    procesoGuardado.areasConPermisos = campoEsValido({ campoAValidar: Areas }) ? Areas : [];
                    comun.mensajeDeAlerta(Satisfactorio);
                }
                if(visualizarCargaDeInformacion)
                    comun.SeEstaCargandoInformacion(false);
            }
            catch(excepcion) {
                console.log(excepcion);
                comun.SeEstaCargandoInformacion(false);
                comun.mensajeDeAlerta(enumeraciones.error.E500, null, null);
            }
            return procesoGuardado;
        },
        evtCambioTipoPermiso: function(evento) { 
            this.CtiposDePermisos.valorDefinido = campoEsValido({ campoAValidar: evento.target.value }) ? parseInt(evento.target.value) : 1;
            this.CtiposDePermisos.seleccionado = this.CtiposDePermisos.opciones.find(o => o.llave == this.CtiposDePermisos.valorDefinido);
            this.cargarNuevaSeccion({ opcionId: this.CtiposDePermisos.valorDefinido });
        },
        cargarNuevaSeccion: async function({ opcionId }) {
            const { TIPOS } = this.CtiposDePermisos;
            this.limpiarSeccionCasoPermisosPorPagina();
            this.limpiarSeccionCasoPermisosPorSeccion();
            switch(opcionId) {
                case TIPOS.PAGINAS: 
                    await await Promise.resolve(this.cargarInformacionTablaAreas());
                break;
                case TIPOS.SECCIONES: 
                    
                break;
                default: 
                break;
            }
        },
        limpiarSeccionCasoPermisosPorPagina: function() {
            // Se actualizan los valores del catalogo tipos de paginas
            this.CTipoDePagina.seleccionada  = null;
            this.CTipoDePagina.valorDefinido = -1;
            this.CTipoDePagina.contRender ++;

            // se actualiza la tabla de areas de intranet
            this.tablaAreasIntranet.lista = [];
            $('#' + this.tablaAreasIntranet.ID).bootstrapTable('destroy')
        },
        limpiarSeccionCasoPermisosPorSeccion: function() {
            // Se actualizan los valores del catalogo tipos de paginas
            this.secciones.filtros.contRender ++;
            this.secciones.filtros.seleccionada = null;

            // se actualiza la tabla de areas de intranet
            this.tablaPuestosJuridicos.seRealizaronMovimientos = false
            this.tablaPuestosJuridicos.lista = [];
            $('#' + this.tablaPuestosJuridicos.ID).bootstrapTable('destroy')
        },
        evtCambioTipoDePagina: async function(evento, paginaObj) { 
            this.CTipoDePagina.valorDefinido = parseInt(evento.target.value);
            this.CTipoDePagina.seleccionada = paginaObj;
            if(campoEsValido({ campoAValidar: paginaObj })) {
                await Promise.resolve(this.cargarInformacionTablaAreas());
            }
            console.log(paginaObj)
        },
        getAreasIntranetDB: async function({ peticion, visualizarCargaDeInformacion = true }) { 
            try {
                const SERVIDOR = api.conexion;
                const METODO_API_OBTENER = api.SICPO.catalogos.C030AreasDeIntranet;
                let urlApi = SERVIDOR + METODO_API_OBTENER;
                let peticionAPI = peticion;
                const HEADER_PARA_ENVIO_ARCHIVOS = false;
                const HEADER_PARA_ARRAY_BUFFER = false;
                let headerPeticion = comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal, HEADER_PARA_ENVIO_ARCHIVOS,HEADER_PARA_ARRAY_BUFFER);
                if(visualizarCargaDeInformacion)
                    comun.SeEstaCargandoInformacion(true);
                const RESPUESTA_SOLICITUD = await axios.post(urlApi, peticionAPI, headerPeticion);
                const DATOS_RESPUESTA = await RESPUESTA_SOLICITUD.data;
                let { SiHayError, Error, AreasDeIntranet } = DATOS_RESPUESTA;
                if (SiHayError) {
                    let mensajeError = Error.Mensaje;
                    console.log(Error);
                    if(visualizarCargaDeInformacion)
                        comun.SeEstaCargandoInformacion(false);
                    comun.mensajeDeAlerta(mensajeError);
                    const { ID } = this.tablaAreasIntranet;
                    this.tablaAreasIntranet.listaDB = [];
                    await Promise.resolve(this.inicializarTabla({ idReferencia: ID, elementos: [] }));
                } 
                else { 
                    this.tablaAreasIntranet.listaDB = campoEsValido({ campoAValidar: AreasDeIntranet }) ? AreasDeIntranet : [];
                }
                if(visualizarCargaDeInformacion)
                    comun.SeEstaCargandoInformacion(false);
            }
            catch(excepcion) {
                console.log(excepcion);
                comun.SeEstaCargandoInformacion(false);
                comun.mensajeDeAlerta(enumeraciones.error.E500, null, null);
            }
        },
        getPuestosJuridicosDB: async function({ peticion, visualizarCargaDeInformacion = true }) { 
            try {
                const SERVIDOR = api.conexion;
                const METODO_API_OBTENER = api.PJ.catalogos.C005PuestosJuridicos;
                let urlApi = SERVIDOR + METODO_API_OBTENER;
                let peticionAPI = peticion;
                const HEADER_PARA_ENVIO_ARCHIVOS = false;
                const HEADER_PARA_ARRAY_BUFFER = false;
                let headerPeticion = comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal, HEADER_PARA_ENVIO_ARCHIVOS,HEADER_PARA_ARRAY_BUFFER);
                if(visualizarCargaDeInformacion)
                    comun.SeEstaCargandoInformacion(true);
                const RESPUESTA_SOLICITUD = await axios.post(urlApi, peticionAPI, headerPeticion);
                const DATOS_RESPUESTA = await RESPUESTA_SOLICITUD.data;
                let { SiHayError, Error, PuestosJuridicos } = DATOS_RESPUESTA;
                if (SiHayError) {
                    let mensajeError = Error.Mensaje;
                    console.log(Error);
                    if(visualizarCargaDeInformacion)
                        comun.SeEstaCargandoInformacion(false);
                    comun.mensajeDeAlerta(mensajeError);
                    this.tablaPuestosJuridicos.listaDB = [];
                } 
                else { 
                    this.tablaPuestosJuridicos.listaDB = campoEsValido({ campoAValidar: PuestosJuridicos }) ? PuestosJuridicos : [];
                }
                if(visualizarCargaDeInformacion)
                    comun.SeEstaCargandoInformacion(false);
            }
            catch(excepcion) {
                console.log(excepcion);
                comun.SeEstaCargandoInformacion(false);
                comun.mensajeDeAlerta(enumeraciones.error.E500, null, null);
            }
        },
        cargarInformacionTablaPuestos: async function() { debugger
            const { ID, listaDB } = this.tablaPuestosJuridicos;
            if(campoEsValido({ campoAValidar: listaDB })) {
                const cbEventoCheck = () => { this.tablaPuestosJuridicos.seRealizaronMovimientos = true };
                this.tablaPuestosJuridicos.lista = await Promise.resolve(this.PuestoDBaPuestoObjTabla({ puestos: listaDB }));
                await Promise.resolve(this.inicializarTabla({ idReferencia: ID, elementos: this.tablaPuestosJuridicos.lista, callbackCheck: cbEventoCheck }));
            }
        },
        PuestoDBaPuestoObjTabla: async function({ puestos }) {
            const { seleccionada } = this.secciones.filtros;
            let puestosObj = puestos.map(pDB => {
                let puestoObj = { ...pDB };
                puestoObj.seleccionado = (campoEsValido({ campoAValidar: seleccionada }) && campoEsValido({ campoAValidar: seleccionada.PuestosJuridicos }))
                    ? seleccionada.PuestosJuridicos.some(puestoId => puestoId == puestoObj.PuestoJuridicoId) : false;
                return puestoObj;
            });
            return puestosObj;
        },
        cargarInformacionTablaAreas: async function() {
            const { ID, listaDB } = this.tablaAreasIntranet;
            if(campoEsValido({ campoAValidar: listaDB })) {
                const cbEventoCheck = () => {  };
                this.tablaAreasIntranet.lista = await Promise.resolve(this.AreaDBaAreaObjTabla({ areas: listaDB }));
                await Promise.resolve(this.inicializarTabla({ idReferencia: ID, elementos: this.tablaAreasIntranet.lista, callbackCheck: cbEventoCheck }));
            }
        },
        AreaDBaAreaObjTabla: async function({ areas }) {
            const { seleccionada } = this.CTipoDePagina;
            let areasObj = areas.map(aDB => {
                let areaObj = { ...aDB };
                areaObj.seleccionado = (campoEsValido({ campoAValidar: seleccionada }) && campoEsValido({ campoAValidar: seleccionada.AreasALasQuePertenece }))
                    ? seleccionada.AreasALasQuePertenece.some(area => area.AreaDeIntranetId == areaObj.AreaDeIntranetId) : false;
                return areaObj;
            });
            return areasObj;
        },
        inicializarTabla: async function({ idReferencia, elementos, callbackCheck = () => {} }) { 
            this.$nextTick(() => {
                $("#" + idReferencia).off("check.bs.table uncheck.bs.table check-all.bs.table uncheck-all.bs.table page-change.bs.table sort.bs.table");
                $("#" + idReferencia).bootstrapTable({  data: elementos });      
                $("#" + idReferencia).bootstrapTable('load', elementos ); 
                $("#" + idReferencia).on('check.bs.table',(e, row) => {
                    /* this.evtContenidoSeleccionado({ contenido: row }); */
                    callbackCheck();
                });
                $("#" + idReferencia).on('uncheck.bs.table',(e, row) => {
                    /* const TIPO_CHECK = 'UNO';
                    this.evtRemoverContenidosDeListaSeleccionados({ tipoCheck: TIPO_CHECK, contenidos: row }); */
                    callbackCheck();
                });
                $("#" + idReferencia).on('check-all.bs.table',(e, rows) => {
                    /* this.evtSeleccionarTodosLosContenidos({ contenidos: rows }); */
                    callbackCheck();
                });
                $("#" + idReferencia).on('uncheck-all.bs.table',(e, rowsAfter, rowsBefore) => {
                    /* const TIPO_CHECK = 'MUCHOS';
                    this.evtRemoverContenidosDeListaSeleccionados({ tipoCheck: TIPO_CHECK, contenidos: rowsBefore }); */
                    callbackCheck();
                });
            });
        },
        iniciarProcesoGetAreasDB: async function() {
            const PARAMETROS_GET_AREAS = {
                Nombre: null,
                ConAreasDePJ: false,
                ConPaginas: false
            };
            await Promise.resolve(this.getAreasIntranetDB({ peticion: PARAMETROS_GET_AREAS, visualizarCargaDeInformacion: false }));
            console.log('areas::', this.tablaAreasIntranet.listaDB);
        }
    },
    mounted() {
        const { ID, lista } = this.tablaAreasIntranet;
        this.inicializarTabla({ idReferencia: ID, elementos: lista });

        window.operateEvents = {
            'click .btn-removerSeccion-VADPI': (e, value, row, index) => { 
                const { ID } = this.formularioUsuarios.tablaTemporalPermisos;
                this.removerElementoDeLista({ idTabla: ID, elemento: row, eliminarPor: 'seccionId' });
            },
            'click .btn-usr-agregarAIntranet-VADPI': (e, value, row, index) => { 
                this.ejecutarProcesoGuardarPermisosAPlataformaIntranet({ usuarios: [row.IdUsuario], activar: true });
            },
            'click .btn-usr-verPermisosSecciones-VADPI': (e, value, row, index) => { 
                this.formularioUsuarios.tablaSeccionesUsuario.seleccionado = row;
                this.ejectuarProcesoGetSeccionesUsuario({ usuario: row });
            },
            'click .btn-usr-removerIntranet-VADPI': (e, value, row, index) => { 
                this.ejecutarProcesoGuardarPermisosAPlataformaIntranet({ usuarios: [row.IdUsuario], activar: false });
            },
            'click .btn-removerSeccionDeUsuario-VADPI': (e, value, row, index) => { 
                const { ID } = this.formularioUsuarios.tablaSeccionesUsuario;
                this.removerElementoDeLista({ idTabla: ID, elemento: row, eliminarPor: 'seccionId' });
            }
        };
    },
    async created() {
        comun.SeEstaCargandoInformacion(true);
        await Promise.resolve(this.getPuestosJuridicosDB({ peticion: { EsPrueba: false }, visualizarCargaDeInformacion: false }));
        await Promise.resolve(this.iniciarProcesoGetAreasDB());
        comun.SeEstaCargandoInformacion(false);
    },
    computed: {
        mostrarAsignacionSecciones() {
            return this.formularioUsuarios.tabla.lista.some(u => u.seleccionado);
        },
        getNombreDePagina() {
            return (campoEsValido({ campoAValidar: this.CTipoDePagina.seleccionada }) && campoEsValido({ campoAValidar: this.CTipoDePagina.seleccionada.Titulo }))
                ? this.CTipoDePagina.seleccionada.Titulo : 'Sin nombre';
        },
        getPermisosDePaginaListado() {
            return this.tablaAreasIntranet.lista.filter(a => a.seleccionado);
        },
        mostrarOpcionGuardarPermisosDePagina() {
            return (this.CtiposDePermisos.valorDefinido == this.CtiposDePermisos.TIPOS.PAGINAS && campoEsValido({ campoAValidar: this.CTipoDePagina.seleccionada }));
        },
        mostrarOpcionGuardarPermisosDeSeccion() {
            return (this.CtiposDePermisos.valorDefinido == this.CtiposDePermisos.TIPOS.SECCIONES && campoEsValido({ campoAValidar: this.secciones.filtros.seleccionada }));
        }
    }
}
</script>
<style scoped>
.info-usuario {
    color: rgb(226, 226, 226);
    background-color: #212529;
    border-radius: 4px;
    padding: 1em 1em 1em 1em;
    text-align: center;
    margin-bottom: 1em;
}

#modal-permisos-seccion-usuarios-VADPI .btn-primary {
    background-color: black;
}

#modal-permisos-seccion-usuarios-VADPI .modal-footer {
    border-top: 2px solid rgb(27, 27, 27);
}

#modal-permisos-seccion-usuarios-VADPI .modal-lg {
    max-width: 40% !important;
}

#modal-permisos-seccion-usuarios-VADPI .modal-header {
    /* background-color: rgb(80, 80, 80); */
    background-color: rgb(15, 15, 15);
    border: none;
}

#modal-edicion-secciones-usr-VADPI .btn-primary {
    background-color: black;
}

#modal-edicion-secciones-usr-VADPI .modal-footer {
    border-top: 2px solid rgb(27, 27, 27);
}

#modal-edicion-secciones-usr-VADPI .modal-lg {
    max-width: 40% !important;
}

#modal-edicion-secciones-usr-VADPI .modal-header {
    /* background-color: rgb(80, 80, 80); */
    background-color: rgb(15, 15, 15);
    border: none;
}

#contenedor-principal-permisos .btn-info {
    color: #fff;
    background-color: #05535f;
    border-color: #05535f;
}

#contenedor-principal-permisos .btn-info:hover {
    color: #fff;
    background-color: #033d46;
    border-color: #033d46;
}

.formulario {
    border: 1.3px solid rgb(31, 30, 30);
    border-radius: 4px;
    padding: 1.8em 1em 1em 1.5em;
}

#modal-confirmar-cambio-seccion-VADPI .modal-lg {
    max-width: 30% !important;
}

#modal-confirmar-cambio-seccion-VADPI .modal-header {
    background-color: rgb(36, 34, 34);;
    border: none;
}

#modal-confirmar-cambio-seccion-VADPI .modal-dialog {
    position: relative;
    top: 40%;
    transform: translateY(-50%);
}

#modal-confirmar-remover-seccion-usr-VADPI .modal-lg {
    max-width: 30% !important;
}

#modal-confirmar-remover-seccion-usr-VADPI .modal-header {
    background-color: rgb(36, 34, 34);;
    border: none;
}

#modal-confirmar-remover-seccion-usr-VADPI .modal-dialog {
    position: relative;
    top: 40%;
    transform: translateY(-50%);
}


.lista-VADPI .list-group-item {
    color: black;
    background-color: rgb(224, 224, 224);
    font-size: 1.2em;
    font-weight: bold;
}

.lista-VADPI {
    height: 38em;
    max-height: 38em;
    overflow-x: hidden;
    padding-right: 0.5em;
}

.lista-VADPI .list-group{
    max-height: 300px;
}

.lista-VADPI .disabled {
    background-color: #212529;
    color: #fff;
}


#contenedor-principal-permisos .card-body {
    background-color: #323335;
}

#contenedor-principal-permisos .card {
    border: 1px solid rgb(129, 129, 129) !important;
}

#contenedor-principal-permisos .card-header {
    background-color: rgb(80, 80, 80);
}

#encabezados-tp {
    margin-bottom: 1em;
}

#encabezados-tp h1 {
    margin-bottom: 0;
    font-weight: bold;
}

#encabezados-tp h3 {
    font-size: 2em;
    color: rgb(175, 175, 175);
}

#encabezados-tp h4 {
    font-size: 1.5em;
    color: rgb(214, 214, 214);
}

.hr-titulo {
    height:0.5em;
    width: 6em;
    border:none;
    background-color:#ffffff;
}
</style>
<style>
.tabla-VADPI-intranet .btn-secondary {
    width: 2.5rem;
    background-color: #1f1f21;
    color: white;
    padding: 0.3em 0.3em 0.3em 0.3em;
    box-shadow: none;
}

.tabla-VADPI-intranet .form-control {
    background-color: white;
    color: rgb(63, 62, 62);
    border: 1px solid #656161 !important;
    height: 2.5em;
    width: 40vmin;
}

.tabla-VADPI-intranet td {
    background-color: rgb(238, 238, 238);
    vertical-align: middle;
    font-weight: bold;
}

.tabla-VADPI-intranet .borderless td, .tabla-VADPI-intranet .borderless th {
    border: none;
    border-bottom: 1px solid #d8d7d7 !important;
}

.tabla-VADPI-intranet .btn-light {
    background-color: white;
    border: 1px solid #4F4949;
    color: #AF9C9C;
    font-size: 1em;
}


.tabla-VADPI-intranet .btn-edt-cont-intr:hover, .tabla-VADPI-intranet .btn-edt-cont-intr:focus {
    background-color: #009bca;
    border: 1px solid #009bca;
    color: white;
}

.tabla-VADPI-intranet .btn-rmv-cont-intr:hover, .tabla-VADPI-intranet .btn-rmv-cont-intr:focus {
    background-color: #810000;
    border: 1px solid #810000;
    color: white;
}

.tabla-VADPI-intranet table {
    table-layout: fixed;
    width: 100%;
    word-wrap:break-word;
}

.tabla-VADPI-intranet .dropdown-toggle {
    width: 3.3rem;
    background-color: #1f1f21;
    color: white;
}

.tabla-VADPI-intranet .pagination > li > a {
    background-color: white;
    color: #121213;
}

.tabla-VADPI-intranet .pagination > .active > a {
    color: white;
    background-color:  #1f1f21;
    border: solid 1px #676666;
}

.tabla-VADPI-intranet > .active > a:hover {
    background-color:  #21211f;
    border: solid 1px #676666;
} 

</style>


// WEBPACK FOOTER //
// src/components/SICPO/Intranet/Permisos/CPermisos.vue